<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <rect x="1" y="6" width="15" height="2.2" rx="1.1" fill="#E5E5E5"/>
  <rect x="2.5" y="8.2" width="1.5" height="5.8" rx="0.5" fill="#E5E5E5"/>
  <rect x="13" y="8.2" width="1.5" height="5.8" rx="0.5" fill="#E5E5E5"/>
  <rect x="1.5" y="13.5" width="3.5" height="1.5" rx="0.6" fill="#E5E5E5"/>
  <rect x="12" y="13.5" width="3.5" height="1.5" rx="0.6" fill="#E5E5E5"/>
  <rect x="4" y="9.5" width="9" height="1.2" rx="0.4" fill="#E5E5E5"/>
</svg>
